module.exports = __webpack_public_path__ + "img/10870_L.84b765e5.png";